var map = {
	"./agenda/router/routes.js": "9fb0",
	"./auxiliares/ajuda/router/routes.js": "7a0b",
	"./auxiliares/atualizacoes/router/routes.js": "9aa4",
	"./auxiliares/notificacoes/router/routes.js": "ef3e",
	"./auxiliares/termos/router/routes.js": "9137",
	"./auxiliares/videos_tutoriais/router/routes.js": "5c76",
	"./cadastros/auxiliares/campos_extras/router/routes.js": "3cd6",
	"./cadastros/auxiliares/tipos_contatos/router/routes.js": "77af",
	"./cadastros/auxiliares/tipos_enderecos/router/routes.js": "ce76",
	"./cadastros/clientes/router/routes.js": "84f9",
	"./cadastros/fornecedores/router/routes.js": "a1a8",
	"./cadastros/funcionarios/router/routes.js": "923d",
	"./cadastros/transportadoras/router/routes.js": "d6cb",
	"./carteira/router/routes.js": "592c",
	"./chat-ia/router/routes.js": "94a4",
	"./configuracoes/avisos_email/router/routes.js": "5a63",
	"./configuracoes/backup_dados/router/routes.js": "345e",
	"./configuracoes/certificado_digital/router/routes.js": "c72c",
	"./configuracoes/dominios/router/routes.js": "cd7b",
	"./configuracoes/exclusao_dados/router/routes.js": "5bb6",
	"./configuracoes/gerais/router/routes.js": "d778",
	"./configuracoes/grupos_usuarios/router/routes.js": "a317",
	"./configuracoes/lojas/router/routes.js": "2c03",
	"./configuracoes/marca_empresa/router/routes.js": "9834",
	"./configuracoes/modelos_emails/router/routes.js": "5163",
	"./configuracoes/permissoes/router/routes.js": "9b95",
	"./configuracoes/planos/router/routes.js": "b06c",
	"./configuracoes/usuarios/router/routes.js": "5ca0",
	"./contratos/router/routes.js": "cd29",
	"./dashboard/router/routes.js": "21b7",
	"./erros/router/routes.js": "f900",
	"./estoque/router/routes.js": "db82",
	"./financeiro/movimentacoes/router/routes.js": "821d",
	"./financeiro/router/routes.js": "7e07",
	"./fiscal/router/routes.js": "fe6e",
	"./pedidos/router/routes.js": "8bb5",
	"./produtos/auxiliares/campos_extras/router/routes.js": "67c8",
	"./produtos/auxiliares/grades/router/routes.js": "5076",
	"./produtos/auxiliares/grupos_produtos/router/routes.js": "6e26",
	"./produtos/auxiliares/marcas_produtos/router/routes.js": "a3e0",
	"./produtos/auxiliares/unidades_produtos/router/routes.js": "9ce2",
	"./produtos/etiquetas/router/routes.js": "45fa",
	"./produtos/gerenciar_produtos/router/routes.js": "60c7",
	"./produtos/valores_vendas/router/routes.js": "18fb",
	"./relatorios/cadastros/router/routes.js": "64b8",
	"./relatorios/curvas_abc/router/routes.js": "95c0",
	"./relatorios/usuarios_logs/router/routes.js": "3b3d",
	"./servicos/router/routes.js": "284b",
	"./sistema/design_system/router/routes.js": "8f53",
	"./sistema/router/routes.js": "ad4e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80b1";